import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=4596b160&scoped=true&"
import script from "./GlobalLayout.vue?vue&type=script&lang=js&"
export * from "./GlobalLayout.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLayout.vue?vue&type=style&index=0&id=4596b160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596b160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
